export const common = {
    email: {
        type: 'string',
        length: { minimum: 1, maximum: 65 },
        presence: { allowEmpty: false },
    },
    default: {
        type: 'string',
        presence: { allowEmpty: false },
    },
    options: {
        type: 'object',
        presence: { allowEmpty: false },
    },
};
